// extracted by mini-css-extract-plugin
export default {"Container":"MiddleModelVideo_Container__nDATy","UploadBox_right":"MiddleModelVideo_UploadBox_right__wF9Mu","UploadBox_right_":"MiddleModelVideo_UploadBox_right___VZ0y0"};